import { render, staticRenderFns } from "./ComparisonDashboard.vue?vue&type=template&id=7dd51b42&scoped=true&"
import script from "./ComparisonDashboard.vue?vue&type=script&lang=js&"
export * from "./ComparisonDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ComparisonDashboard.vue?vue&type=style&index=0&id=7dd51b42&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd51b42",
  null
  
)

export default component.exports